/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {useTranslation} from 'react-i18next';

import {BolmateProductRow, BolmateSectionCard} from '../../../controls';

import {OverviewStock} from '../../../../util/interfaces';

import {OverviewSectionState} from '../useOverviewSection';

export default function LowStock(props: OverviewSectionState<OverviewStock>) {
    const {items, loading, loadingMore, error, hasMore, onLoadMore} = props;
    const {t} = useTranslation();

    function renderRow(item: OverviewStock, index: number) {
        return (
            <BolmateProductRow
                key={index}
                imageUrl={item.image_url}
                title={item.title}
                titleHref={item.product_url}
                ean={item.ean}
                badge={{
                    label: t('overview.lowStock.badge', '{{count}} stuks op voorraad', {count: item.stock}),
                    color: item.stock === 0 ? 'red' : 'orange',
                    icon: 'mdi:alert-outline'
                }}
            />
        );
    }

    return (
        <BolmateSectionCard
            title={t('overview.sections.lowStock', 'Lage voorraad')}
            loading={loading}
            loadingMore={loadingMore}
            empty={!items.length}
            emptyLabel={t('overview.lowStock.empty', 'Geen producten met lage voorraad')}
            error={error ? t('overview.sectionError', 'Deze sectie kon niet geladen worden') : undefined}
            hasMore={hasMore}
            loadMoreLabel={t('overview.loadMore', 'Meer laden')}
            onLoadMore={onLoadMore}
        >
            {items.map(renderRow)}
        </BolmateSectionCard>
    );
}
